import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class agencyApi<Agency> extends BaseAPI {
  // constructor() {}

  public getAllAgencies: () => Promise<Agency[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/agency`)).data.output;
  };

  // public getAgencyById: (id: number) => Promise<Agency[]> = async (id: number) => {
  //   return (await axios.get(`${baseUrl}/agency/${id}`)).data.output;
  // };

  public getAgencyByAgencyId: (id: number) => Promise<Agency[]> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/agency/getById/${id}`)).data.output;
  };

  public getFilteredAgencies: () => Promise<Agency[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/agency/filtered`)).data.output;
  };

  public updateAgency: (agency: Agency) => Promise<Agency> = async (agency: Agency) => {
    return (await BaseAPI.axios.post(`${baseUrl}/agency`, agency)).data.output;
  };

  public createAgency: (agency: Agency) => Promise<Agency> = async (agency: Agency) => {
    return (await BaseAPI.axios.put(`${baseUrl}/agency`, agency)).data.output;
  };
}

export const agencyAPI = new agencyApi();
